import React from "react";
import isoCert from "../assets/about/iso_cert.png"; // ganti path sesuai file kamu

const About = () => {
  return (
    <section id="about" style={{ padding: "4rem 2rem", background: "white" }}>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          gap: "2rem",
          maxWidth: "1200px",
          margin: "0 auto",
          flexWrap: "wrap",
        }}
      >
        {/* Gambar Sertifikat */}
        <div style={{ flex: "1 1 350px", textAlign: "center" }}>
          <img
            src={isoCert}
            alt="ISO 9001:2015 Certificate"
            style={{
              width: "100%",
              maxWidth: "400px",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            }}
          />
        </div>

        {/* Teks About Us */}
        <div style={{ flex: "2 1 600px", textAlign: "left", lineHeight: "1.7" }}>
          <h2
            style={{
              fontSize: "2rem",
              fontWeight: "bold",
              marginBottom: "1rem",
            }}
          >
            About Us
          </h2>
          <p>
            PT. Oto Kreasi Indonesia (OKI) adalah perusahaan manufaktur yang berdiri
            sejak Juni 2023 dan berlokasi di Kawasan Industri Jababeka, Cikarang Timur,
            Bekasi. Kami berfokus pada produksi komponen otomotif dan elektronik,
            khususnya produk berbasis <em>die-cutting</em>, <em>packaging</em>, serta
            part untuk sistem Air Conditioner.
          </p>
          <p>
            Dengan sertifikasi <strong>ISO 9001:2015</strong>, kami berkomitmen
            menghadirkan produk berkualitas tinggi yang mendukung kebutuhan industri
            otomotif di Indonesia.
          </p>
          <p>
            PT. OKI tidak hanya berfokus pada kualitas produk, tetapi juga pada{" "}
            <strong>kepuasan pelanggan</strong> melalui layanan yang cepat, tepat, dan
            terpercaya. Dengan didukung <strong>fasilitas produksi modern</strong> serta{" "}
            <strong>alat uji kualitas berstandar internasional</strong>, kami memastikan
            setiap produk memenuhi standar ketat industri otomotif.
          </p>
          <p>
            Kami juga menjalin kerja sama dengan berbagai perusahaan otomotif terkemuka
            seperti <strong>PT. Sekiso Industri Indonesia</strong>,{" "}
            <strong>PT. Suzuki Indomobil Indonesia</strong>,{" "}
            <strong>PT. Ingress Indonesia</strong>, dan lainnya. Hal ini menjadikan OKI
            sebagai <strong>mitra terpercaya</strong> dalam rantai pasok industri
            otomotif nasional.
          </p>
          <p>
            OKI berkomitmen untuk terus <strong>berinovasi</strong>, meningkatkan
            kapasitas produksi, serta memperluas jaringan agar dapat memberikan
            kontribusi yang lebih besar bagi perkembangan industri otomotif dan
            elektronik di Indonesia.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
